import type { ButtonProps } from '@mui/joy';
import { Button } from '@mui/joy';
import { createLink } from '@tanstack/react-router';
import { forwardRef } from 'react';

type ButtonLinkProps = Omit<ButtonProps<'a'>, 'component'>;

const UnwrappedButtonLink = forwardRef<HTMLAnchorElement, ButtonLinkProps>((props, ref) => (
  <Button ref={ref} component="a" {...props} />
));

export const ButtonLink = createLink(UnwrappedButtonLink);
